// Reply-rail connector colours. A connector segment is dim (border colour) at rest and lights up
// (foreground) only when its OWN rail is hovered — its avatar-down line plus the elbows of its direct
// replies, and nothing else. The "lit" state is React hover state threaded down from each rail (see
// `railHovered` in ThoughtThread.tsx / ThoughtInDiscussionCardDisplayer.tsx), NOT CSS group-hover:
// a shared `group/cell` name made a parent's hover cascade into every descendant rail, and the
// whole-tree `group/thread` flashed the entire trunk on any hover. Per-rail state scopes the highlight
// to exactly one rail and never its descendants.
//
// DISCUSSION-71 — the REST colour is the full `--border` token, with no borrowed alpha. On a phone
// the rail plus ~49 CSS px of indent is the whole statement of who is answering whom, and at
// `bg-border/70` it measured 2.43:1 in light and 2.78:1 in dark against the page: under WCAG 1.4.11's
// 3:1 non-text floor, and below the ordinary card hairline in the SAME frame at 3.91:1. The gap was
// the `/70` alone — `--border` had already been retuned specifically to clear 1.4.11, and this file
// then spent 30% of it. Dropping the alpha makes the rail exactly as separable as the hairline the
// reader is already using elsewhere on the page, with no token change and no effect on any other
// surface. The LIT value keeps its alpha: it is a hover accent over the rest colour, not a boundary,
// and `foreground/70` stays plainly distinguishable from `border`.
//
// ⚠️ Still open on DISCUSSION-71 after this change: the lit state is wired to onMouseEnter/onMouseLeave
// only, so the affordance built to disambiguate neighbouring rails can never fire on the device where
// the ambiguity is worst. What replaces it on touch (a tap-to-highlight on the rail, or accepting that
// the rail carries the meaning unaided) is a product call, not a mechanism — left for wave 19.
const CONNECTOR_TRANSITION = "transition-colors duration-200 ease-in-out";

export function threadConnectorLineClass(lit: boolean): string {
    return `${CONNECTOR_TRANSITION} ${lit ? "bg-foreground/70" : "bg-border"}`;
}

export function threadConnectorElbowClass(lit: boolean): string {
    return `${CONNECTOR_TRANSITION} ${lit ? "border-foreground/70" : "border-border"}`;
}
